module.exports = __webpack_public_path__ + "images/backgrounds/mountain/medium.07627e0760eb74e7109a.jpg";